var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((_vm.column.field === 'weekProperties') & (_vm.row !== null))?_c('div',[_vm._v(_vm._s(_vm.weekProperties(_vm.row.weekProperties)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }